// extracted by mini-css-extract-plugin
module.exports = {"root":"AnimatedBar_root__nVBJa","bar":"AnimatedBar_bar__gg2cm"};